module.exports = __webpack_public_path__ + "static/media/AsthaTechnology.0593116f.jpg";